/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Speechmatics_Target_Language_GalicianInputs */

const en_speechmatics_target_language_galician = /** @type {(inputs: Speechmatics_Target_Language_GalicianInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Galician`)
};

const fr_speechmatics_target_language_galician = /** @type {(inputs: Speechmatics_Target_Language_GalicianInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Galicien`)
};

const de_speechmatics_target_language_galician = /** @type {(inputs: Speechmatics_Target_Language_GalicianInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`galizisch`)
};

const it_speechmatics_target_language_galician = /** @type {(inputs: Speechmatics_Target_Language_GalicianInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`galiziano`)
};

const ru_speechmatics_target_language_galician = /** @type {(inputs: Speechmatics_Target_Language_GalicianInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`галисийский`)
};

const es_speechmatics_target_language_galician = /** @type {(inputs: Speechmatics_Target_Language_GalicianInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`gallego`)
};

const zh_cn2_speechmatics_target_language_galician = /** @type {(inputs: Speechmatics_Target_Language_GalicianInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`加利西亚语`)
};

const ja_speechmatics_target_language_galician = /** @type {(inputs: Speechmatics_Target_Language_GalicianInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ガリシア語`)
};

const hi_speechmatics_target_language_galician = /** @type {(inputs: Speechmatics_Target_Language_GalicianInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`गैलिशियन्`)
};

const pt_pt2_speechmatics_target_language_galician = /** @type {(inputs: Speechmatics_Target_Language_GalicianInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`galego`)
};

/**
* | output |
* | --- |
* | "Galician" |
*
* @param {Speechmatics_Target_Language_GalicianInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const speechmatics_target_language_galician = /** @type {((inputs?: Speechmatics_Target_Language_GalicianInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Speechmatics_Target_Language_GalicianInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_speechmatics_target_language_galician(inputs)
	if (locale === "de") return de_speechmatics_target_language_galician(inputs)
	if (locale === "it") return it_speechmatics_target_language_galician(inputs)
	if (locale === "ru") return ru_speechmatics_target_language_galician(inputs)
	if (locale === "es") return es_speechmatics_target_language_galician(inputs)
	if (locale === "zh-CN") return zh_cn2_speechmatics_target_language_galician(inputs)
	if (locale === "ja") return ja_speechmatics_target_language_galician(inputs)
	if (locale === "hi") return hi_speechmatics_target_language_galician(inputs)
	if (locale === "pt-PT") return pt_pt2_speechmatics_target_language_galician(inputs)
	return en_speechmatics_target_language_galician(inputs)
});